import { render } from "./LeaseExpired.vue?vue&type=template&id=7a736612&scoped=true"
import script from "./LeaseExpired.vue?vue&type=script&lang=js"
export * from "./LeaseExpired.vue?vue&type=script&lang=js"

import "./LeaseExpired.vue?vue&type=style&index=0&id=7a736612&scoped=true&lang=css"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a736612"]])

export default __exports__